import { COMPONENT_FLAGS } from '../utils/componentDisplayFlags';

const useComponentFlag = (component: string): boolean => {
  return !!COMPONENT_FLAGS[component];
};

export default useComponentFlag;
